import PropTypes from 'prop-types';
import { Stack } from '@etg/wings';
import { useTranslation, useSiteContext } from '@eti/providers';
import { BoundNew } from '@eti/types';
import { duration as durationUtil } from '@eti/utils';
import {
  boundIncludesTrainSegments,
  getBoundAsSegment,
  getBoundType,
} from '../../../../widgets/trip-details/utils/format';
import ReviewModalBoundHeader from './ReviewModalBoundHeader';
import ReviewTripDetailsSegment from './ReviewTripDetailsSegment';
import ReviewTripDetailsEventSegments from './ReviewTripDetailsEventSegments';

const ReviewTripDetailsBound = ({ bound, boundNumber, isMultiStop }) => {
  const { language, timeFormat } = useSiteContext();
  const { t } = useTranslation();
  const boundSegment = getBoundAsSegment(bound.segments, boundNumber, bound.includedCheckedBaggage);
  const { duration } = boundSegment;
  const includesTrainSegments = boundIncludesTrainSegments(bound.segments);

  return (
    <Stack
      data-testid={`travelerDetails-reviewModal-flightInformation-bound-${boundNumber}`}
      spacing={8}
    >
      <ReviewModalBoundHeader
        boundNumber={boundNumber}
        departureAt={`${t(
          'TravelerDetails.Review.Modal.FlightDetails.Duration',
        )} ${durationUtil.getDuration(duration, language.code, timeFormat)}`}
        includesTrainSegments={includesTrainSegments}
        isMultiStop={isMultiStop}
        type={getBoundType(boundNumber - 1)}
      />
      {bound.segments.map((segment, index) =>
        segment.__typename === 'TripSegment' ? (
          <ReviewTripDetailsSegment
            arrivedAt={segment.arrivedAt}
            boundNumber={boundNumber}
            departuredAt={segment.departuredAt}
            destination={segment.destination}
            duration={segment.duration}
            index={index}
            key={`${boundNumber}-${segment.flightNumber}-${segment.segmentId}`}
            marketingCarrier={segment.marketingCarrier}
            origin={segment.origin}
          />
        ) : (
          <ReviewTripDetailsEventSegments
            boundNumber={boundNumber}
            duration={segment.duration}
            index={index}
            key={`${boundNumber}-${index + 1}-eventSegment`}
            types={segment.types}
          />
        ),
      )}
    </Stack>
  );
};

ReviewTripDetailsBound.propTypes = {
  bound: BoundNew,
  boundNumber: PropTypes.number,
  isMultiStop: PropTypes.bool,
};

export default ReviewTripDetailsBound;
